import { Theme } from '@mui/material';
import { AuditLog } from '@oxappsec/ox-unified-audit-logger';
import { FC } from 'react';
import { makeStyles } from 'tss-react/mui';
import BaseCard from './BaseCard';
import CardSwitcher from './CardSwitcher';

const AuditLogCard: FC<React.PropsWithChildren<AuditLogCardProps>> = ({
  auditLog,
}) => {
  const { classes } = useStyles();

  return (
    <div className={classes.auditLogCard}>
      <div className={classes.footer}>
        <div className={classes.info}>
          <BaseCard auditLog={auditLog} />
        </div>
        <div className={classes.info}>
          <CardSwitcher auditLog={auditLog} />
        </div>
      </div>
    </div>
  );
};
const useStyles = makeStyles()((theme: Theme) => ({
  auditLogCard: {
    paddingBlock: theme.spacing(2),
    paddingInline: theme.spacing(3),
  },
  footer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    gap: theme.spacing(20),
  },
  info: {
    width: '50%',
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
  },
}));

export interface AuditLogCardProps {
  auditLog: AuditLog;
}

export default AuditLogCard;
